
export const sepeteEkle = book => {
    return { type: 'SEPETE_EKLE', payload: book }
}